import { AutocompleteOption } from '@interfaces';
import { getGraduationYear } from '@utils/studentProgress';

export const gradeOptions: AutocompleteOption[] = [
  { label: `Grade 8 (graduating in ${getGraduationYear(8)})`, value: '8' },
  { label: `Grade 9 (graduating in ${getGraduationYear(9)})`, value: '9' },
  { label: `Grade 10 (graduating in ${getGraduationYear(10)})`, value: '10' },
  { label: `Grade 11 (graduating in ${getGraduationYear(11)})`, value: '11' },
  { label: `Grade 12 (graduating in ${getGraduationYear(12)})`, value: '12' },
  { label: 'In college', value: 'college' },
  { label: 'In grad school', value: 'grad_school' },
  { label: 'Working full time', value: 'working' },
  { label: 'Something else...', value: 'other' },
];
